export default __webpack_public_path__ + "static/lgbtq-pr-all-5-943b36d0cf9da47161bdf04b3a4eeeed.jpg";